import { render, staticRenderFns } from "./MyDormGalleryThumb.vue?vue&type=template&id=96a29870&"
import script from "./MyDormGalleryThumb.vue?vue&type=script&lang=js&"
export * from "./MyDormGalleryThumb.vue?vue&type=script&lang=js&"
import style0 from "./MyDormGalleryThumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports